// frontend/src/components/common/FieldLine.jsx
//
// A "Label: value" line whose value may be a form field. A field does not make
// the line taller, so a stack or a row of these lines keeps one rhythm
// whether a line holds a field or text; the taller field is centred on the
// line and reaches into the space around it (FieldLine.css).
//
// The label names the field: a field shown without its own label reads the
// label's id through `useFieldLineLabel()`. AppDatePicker refuses to render
// unnamed, so a date field beside text cannot be placed outside one.

import { useId } from 'react';
import { FieldLineLabel } from './fieldLineLabel';
import './FieldLine.css';

function FieldLine({ label, children }) {
  const labelId = useId();
  return (
    <div className="field-line">
      <span id={labelId} className="field-line-label">{label}</span>
      <FieldLineLabel.Provider value={labelId}>{children}</FieldLineLabel.Provider>
    </div>
  );
}

export default FieldLine;
